import axios from "axios";
import React, { useState } from "react";
import { Api_Url } from "../../config/config";
import { FaUpload } from "react-icons/fa6";
import { MdCancel, MdDelete } from "react-icons/md";
import { Modal } from "antd";
import { ErrorToast, SuccessToast } from "../../views/ToastComponent";

const PdCheckpoint = ({ profileId, ProfileId }) => {
  const [expenseData, setExpenseData] = useState([]);
  const [checkpointData, setCheckpointData] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formExpenseData, setFormExpenseData] = useState({
    BusinessId: 0,
    ImageUrl: null,
    Latitude: "",
    Longitude: "",
    BusinessPdProfileId: profileId,
    BusinessId: "",
    CheckPointId: 0,
    IsVerified: false,
  });
  const [itemToDelete, setItemToDelete] = useState(null); // State for storing the item to delete

  const handleImageChange = (event) => {
    setFormExpenseData((prev) => ({
      ...prev,
      ImageUrl: event.target.files[0],
      IsVerified: true,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchCurentLocation();

    const formData = new FormData();
    formData.append("BusinessId", formExpenseData.BusinessId);
    formData.append("ImageUrl", formExpenseData.ImageUrl);
    formData.append("Latitude", formExpenseData.Latitude);
    formData.append("Longitude", formExpenseData.Longitude);
    formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId);
    formData.append("BusinessId", formExpenseData.BusinessId);
    formData.append("CheckPointId", formExpenseData.CheckPointId);
    formData.append("IsVerified", formExpenseData.IsVerified);

    const { data } = await axios.post(
      Api_Url + "api/v1/PdCheckPoint",
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    if (data.succeeded) {
      fetchExpenseData();
      setIsModalOpen(false);
      setFormExpenseData((prev) => ({
        ...prev,
        ImageUrl: null,
        Latitude: "",
        Longitude: "",
        BusinessPdProfileId: profileId,
        BusinessId: "",
        CheckPointId: 0,
        IsVerified: false,
      }));
    }
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id); // Store the ID of the item to delete
    setOpenDeleteModal(true); // Open the delete confirmation modal
  };

  const handleConfirmDelete = async () => {
    try {
      const { data } = await axios.delete(`${Api_Url}api/v1/PdCheckPoint/${itemToDelete}`, {
        headers: {
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
        }
      });
      fetchExpenseData(); // Refresh the data after deletion 
      SuccessToast("Deleted Successfully")
    } catch (error) {
      ErrorToast("Soimething Went wrong")
    }finally {
      setOpenDeleteModal(false); // Close the delete confirmation modal
    }
  };

  const fetchExpenseData = async () => {
    const { data } = await axios.get(
      Api_Url + `api/v1/PdCheckPoint/getbyprofileid/${profileId}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    setExpenseData(data.data);
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setFormExpenseData((prev) => ({
          ...prev,
          Latitude: latitude,
          Longitude: longitude,
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  const fetchPdCheckpoint = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/CheckPoint/getby-profileid/" + ProfileId,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setCheckpointData(data?.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  React.useEffect(() => {
    fetchExpenseData();
    fetchCurentLocation();
    fetchPdCheckpoint();
  }, []);

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button
            className="btn btn-primary submit-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Add Checkpoint
          </button>
        </div>
      </div>

      <div className="row mt-4">
        {expenseData.length > 0 &&
          expenseData.map((item) => (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={item.id}>
              <div className="card py-4 px-3">
                <div className="checkpoint-image-container w-100">
                  <img
                    className="w-100 rounded"
                    src={item?.imageUrl}
                    alt="CheckpointImage"
                    style={{ height: "230px" }}
                  />
                </div>
                <div className="d-flex align-items-center gap-1">
                  <h6 className="">Name: </h6>
                  <p>{item?.name}</p>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-1">
                  <MdDelete
                    cursor={"pointer"}
                    size={28}
                    onClick={() => handleDeleteClick(item?.pdCheckPointId)} // Open delete modal on click
                  />
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Add Checkpoint Data */}
      <Modal
        title={<h4>Add Checkpoint</h4>}
        open={isModalOpen}
        centered
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <button
            key="submit"
            className="btn btn-primary submit-btn"
            type="submit"
            onClick={handleSubmit}
          >
            Submit
          </button>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Checkpoint
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={formExpenseData.CheckPointId}
                    onChange={(event) =>
                      setFormExpenseData({
                        ...formExpenseData,
                        CheckPointId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Checkpoint
                    </option>
                    {checkpointData.length > 0 &&
                      checkpointData.map((vehicle) => (
                        <option value={vehicle.id} key={vehicle.id}>
                          {vehicle.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {formExpenseData.CheckPointId !== 0 && (
                <div className="col-sm-12">
                  <input
                    type="file"
                    name=""
                    id="upload-image"
                    onChange={handleImageChange}
                    hidden
                  />
                  {formExpenseData.ImageUrl !== null ? (
                    <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                      {formExpenseData?.ImageUrl?.name}{" "}
                      <MdCancel
                        size={20}
                        onClick={() =>
                          setFormExpenseData((prev) => ({
                            ...prev,
                            ImageUrl: null,
                          }))
                        }
                      />
                    </p>
                  ) : (
                    <label htmlFor="upload-image" className="">
                      <p className="border mb-0 px-2 py-1 rounded">
                        <FaUpload size={20} /> Upload Image
                      </p>
                    </label>
                  )}
                </div>
              )}
            </div>
          </form>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirm Delete"
        open={openDeleteModal}
        centered
        onOk={handleConfirmDelete} // Confirm deletion
        onCancel={() => setOpenDeleteModal(false)} // Close modal without deleting
        okText="Confirm"
        cancelText="Cancel"
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <p>Are you sure you want to delete this checkpoint?</p>
      </Modal>
    </div>
  );
};

export default PdCheckpoint;














// import axios from "axios";
// import React, { useState } from "react";
// import { Api_Url } from "../../config/config";
// import { FaUpload } from "react-icons/fa6";
// import { MdCancel, MdDelete } from "react-icons/md";
// import { Modal } from "antd";

// const PdCheckpoint = ({ profileId, ProfileId }) => {
//   const [expenseData, setExpenseData] = React.useState([]);
//   const [checkpointData, setCheckpointData] = React.useState([]);
//   const [openDeleteModal, SetOpenDeleteModal] = useState(false);
//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [formExpenseData, setFormExpenseData] = React.useState({
//     BusinessId: 0,
//     ImageUrl: null,
//     Latitude: "",
//     Longitude: "",
//     BusinessPdProfileId: profileId,
//     BusinessId: "",
//     CheckPointId: 0,
//     IsVerified: false,
//   });

//   const handleImageChange = (event) => {
//     setFormExpenseData((prev) => ({
//       ...prev,
//       ImageUrl: event.target.files[0],
//       IsVerified: true,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     fetchCurentLocation();

//     const formData = new FormData();
//     formData.append("BusinessId", formExpenseData.BusinessId);
//     formData.append("ImageUrl", formExpenseData.ImageUrl);
//     formData.append("Latitude", formExpenseData.Latitude);
//     formData.append("Longitude", formExpenseData.Longitude);
//     formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId);
//     formData.append("BusinessId", formExpenseData.BusinessId);
//     formData.append("CheckPointId", formExpenseData.CheckPointId);
//     formData.append("IsVerified", formExpenseData.IsVerified);

//     const { data } = await axios.post(
//       Api_Url + "api/v1/PdCheckPoint",
//       formData,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//         },
//       }
//     );
//     if (data.succeeded) {
//       fetchExpenseData();
//       setIsModalOpen(false);
//       console.log("Checkpoint Api Message: ", data.message);
//       setFormExpenseData((prev) => ({
//         ...prev,
//         ImageUrl: null,
//         Latitude: "",
//         Longitude: "",
//         BusinessPdProfileId: profileId,
//         BusinessId: "",
//         CheckPointId: 0,
//         IsVerified: false,
//       }));
//     }
//   };

//   const handleDelete = async (id) => {
//     console.log("Delete ID", id);
//     SetOpenDeleteModal(true);
//     // try {
//     //   const { data } = await axios.delete(`${Api_Url}api/v1/PdCheckPoint/${id}`, {
//     //     headers: {
//     //       Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//     //     }
//     //   });
//     //   fetchExpenseData();
//     //   console.log(data);
//     // } catch (error) {
//     //   console.log(error);
//     // }
//   };

//   const fetchExpenseData = async () => {
//     const { data } = await axios.get(
//       Api_Url + `api/v1/PdCheckPoint/getbyprofileid/${profileId}`,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//         },
//       }
//     );
//     setExpenseData(data.data);
//   };

//   const fetchCurentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setFormExpenseData((prev) => ({
//           ...prev,
//           Latitude: latitude,
//           Longitude: longitude,
//         }));
//       });
//     } else {
//       return "Geolocation is not supported by this browser.";
//     }
//   };

//   const fetchPdCheckpoint = async () => {
//     try {
//       const { data } = await axios.get(
//         Api_Url + "api/v1/CheckPoint/getby-profileid/" + ProfileId,
//         {
//           headers: {
//             Authorization:
//               "Bearer " +
//               JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//           },
//         }
//       );
//       console.log("Checkpoint Data", data);
//       setCheckpointData(data?.data);
//     } catch (error) {
//       console.log("Error: ", error);
//     }
//   };

//   React.useEffect(() => {
//     fetchExpenseData();
//     fetchCurentLocation();
//     fetchPdCheckpoint();
//   }, []);

//   return (
//     <div className="container mt-3">
//       <div className="row">
//         <div className="col-12 d-flex align-items-center justify-content-end">
//           <button
//             className="btn btn-primary submit-btn"
//             onClick={() => setIsModalOpen(true)}
//           >
//             Add Checkpoint
//           </button>
//         </div>
//       </div>

//       <div className="row mt-4">
//         {expenseData.length > 0 &&
//           expenseData.map((item) => (
//             <div className="col-lg-4 col-md-6 col-sm-12 col-12">
//               <div className="card py-4 px-3">
//                 <div className="checkpoint-image-container w-100">
//                   <img
//                     className="w-100 rounded"
//                     src={item?.imageUrl}
//                     alt="CheckpointImage"
//                     style={{ height: "230px" }}
//                   />
//                 </div>
//                 <div className="d-flex align-items-center gap-1">
//                   <h6 className="">Name: </h6>
//                   <p>{item?.name}</p>
//                 </div>
//                 <div className="d-flex align-items-center justify-content-end gap-1">
//                   <MdDelete
//                     cursor={"pointer"}
//                     size={28}
//                     onClick={() => handleDelete(item?.id)}
//                   />
//                 </div>
//               </div>
//             </div>
//           ))}
//       </div>

//       {/* Add Checkpoint Data */}
//       <Modal
//         title={<h4>Add Checkpoint</h4>}
//         open={isModalOpen}
//         centered
//         onOk={() => setIsModalOpen(false)}
//         onCancel={() => setIsModalOpen(false)}
//         footer={[
//           <button
//             key="submit"
//             className="btn btn-primary submit-btn"
//             type="submit"
//             onClick={handleSubmit}
//           >
//             Submit
//           </button>,
//         ]}
//         width={600}
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: "red" }}>X</span>}
//       >
//         <div className="modal-body mt-5">
//           <form>
//             <div className="row">
//               <div className="col-sm-12">
//                 <div className="input-block mb-3">
//                   <label htmlFor="vehicleType" className="col-form-label">
//                     Select Checkpoint
//                   </label>
//                   <select
//                     id="vehicleType"
//                     className="custom-select-style"
//                     value={formExpenseData.CheckPointId}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         CheckPointId: event.target.value,
//                       })
//                     }
//                   >
//                     <option value={0} selected>
//                       Select Checkpoint
//                     </option>
//                     {checkpointData.length > 0 &&
//                       checkpointData.map((vehicle) => (
//                         <option value={vehicle.id}>{vehicle.name}</option>
//                       ))}
//                   </select>
//                 </div>
//               </div>
//               {formExpenseData.CheckPointId != 0 && (
//                 <div className="col-sm-12">
//                   <input
//                     type="file"
//                     name=""
//                     id="upload-image"
//                     onChange={handleImageChange}
//                     hidden
//                   />
//                   {formExpenseData.ImageUrl !== null ? (
//                     <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                       {formExpenseData?.ImageUrl?.name}{" "}
//                       <MdCancel
//                         size={20}
//                         onClick={() =>
//                           setFormExpenseData((prev) => ({
//                             ...prev,
//                             ImageUrl: null,
//                           }))
//                         }
//                       />
//                     </p>
//                   ) : (
//                     <label htmlFor="upload-image" className="">
//                       <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                         <FaUpload size={20} /> Click to Upload
//                       </p>
//                     </label>
//                   )}
//                 </div>
//               )}
//             </div>
//           </form>
//         </div>
//       </Modal>

//       {/* Delete Modal Open */}
//       <Modal
//         title={<h4 className="text-danger">Delete Confirmation</h4>}
//         open={openDeleteModal}
//         onOk={() => SetOpenDeleteModal(false)}
//         onCancel={() => SetOpenDeleteModal(false)}
//         footer={null}
//         width={600}
//         centered
//         maskClosable={false}
//         closeIcon={<span style={{ color: "red", fontSize: "1.2em" }}>✕</span>}
//       >
//         <div className="modal-body text-center p-4">
//           <div className="modal-header mb-4">
//             <h5 className="text-dark">
//               Are you sure you want to delete this item?
//             </h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//           <div className="d-flex justify-content-around">
//             <button
//               className="btn btn-outline-secondary px-4 py-2"
//               onClick={() => SetOpenDeleteModal(false)}
//             >
//               Close{" "}
//             </button>
//             <button
//               className="btn btn-danger px-4 py-2"
//               onClick={() => handleDelete(itemId)}
//             >
//               Confirm
//             </button>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default PdCheckpoint;
